import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchQuestions = () => api.get("/questions").then((r) => r.data);
export const fetchQuickQuestions = () => api.get("/questions/quick").then((r) => r.data);
export const submitAssessment = (payload) => api.post("/assessments", payload).then((r) => r.data);
export const submitQuick = (payload) => api.post("/quick-assessments", payload).then((r) => r.data);
export const fetchAssessment = (id) => api.get(`/assessments/${id}`).then((r) => r.data);
export const fetchShare = (id) => api.get(`/assessments/${id}/share`).then((r) => r.data);
export const fetchLeads = () => api.get("/admin/leads").then((r) => r.data);
export const fetchConfig = () => api.get("/config").then((r) => r.data);
